export enum ProductStatus {
  'EN_VIAJE' = 'En viaje',
}

export enum ProductDeals {
  'EN_OFERTA' = '1',
  'SIN_OFERTA' = '0',
}
